/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AdminPatientChatBubble.vue?vue&type=template&id=1c7f39b1&scoped=true"
import script from "./AdminPatientChatBubble.vue?vue&type=script&lang=js"
export * from "./AdminPatientChatBubble.vue?vue&type=script&lang=js"
import style0 from "./AdminPatientChatBubble.vue?vue&type=style&index=0&id=1c7f39b1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7f39b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c7f39b1')) {
      api.createRecord('1c7f39b1', component.options)
    } else {
      api.reload('1c7f39b1', component.options)
    }
    module.hot.accept("./AdminPatientChatBubble.vue?vue&type=template&id=1c7f39b1&scoped=true", function () {
      api.rerender('1c7f39b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/AdminPatientChatBubble.vue"
export default component.exports